import qs from 'qs'
import axios from 'axios'
import Vue from '../main'
import { getTokenPedigree,removeTokenPedigree } from './authority'
import HttpCheckDeBug from './HttpCheckDeBug'
import { NetworkStatusCodeMessage, ProjectStatusCodeMessage } from './HttpStatusCode'
import router from '@/router'

// 请求类
export default class Request {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  // 创建新实例
  createService() {
    const config = {
      timeout: 4000,
      withCredentials: true,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices', allowDots: true })
    }

    return axios.create(config)
  }

  // 网络层请求状态检测
  checkNetworkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response
    }

    const { status, statusText } = response

    // 配置请求状态相关提示
    const errortext = NetworkStatusCodeMessage[status] || statusText
    const error = new Error(errortext)
    error.status = status
    error.response = response

    throw error
  }

  // 工程层请求状态检测，待对接接口再完善
  checkProjectStatus(response) {
    const { code, ...option } = response.data || {}

    const targetCode = Number(code)

    // 未登录 或 登录失效，可依据工程判断在网络层/工程层进行登陆失效检测
    if (targetCode === 401) {
      const error = new Error(ProjectStatusCodeMessage[targetCode])
      throw error
    }

    return { response, data: { ...option, success: true, code: targetCode } }
  }

  // 发起请求
  fetch(options, method) {
    const { url, data = {}, headers = {} } = options

    // Vue.$toast.fail('系统正在维护升级……')
    // return
    //判断登录状态
    if(!getTokenPedigree()){
      router.replace('/pedigree/form/login')
      return
    }
    // 获取请求链接
    const targetUrl = this.baseUrl + url

    // 获取目标 method
    const targetMethod = method || options.method

    // 获取新实例
    const service = this.createService(targetMethod.toLowerCase())

    // 携带当前用户 Token
    // service.defaults.headers['Authentication'] = getToken(),
    service.defaults.headers = {
      ...service.defaults.headers,
      // Authentication: getToken(),
      ...headers
    }

    // 检测当前 method
    switch (targetMethod.toLowerCase()) {
      case 'get':
        return service.get(targetUrl, { params: data }, { headers })

      case 'post':
        return service.post(targetUrl, data, { headers })

      case 'put':
        return service.put(targetUrl, data, { headers })

      case 'delete':
        return service.delete(targetUrl, { data }, { headers })

      case 'postform':
        let formData = new FormData()
        if (Array.isArray(data)) {
          data.map(value => {
            formData.append('file', value)
          })
        } else {
          Object.entries(data).map(([key, value]) => {
            value && formData.append(key, value)
          })
        }

        return service.post(targetUrl, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
      default:
        return service(options)
    }
  }

  request(options, method) {
    return this.fetch(options, method)
      .then(response => this.checkNetworkStatus(response))
      .then(response => this.checkProjectStatus(response))
      .then(async ({ response, data }) => {
        HttpCheckDeBug({ url: this.baseUrl + options.url, name: options.name, response })

        return data
      })
      .catch(({ response, status }) => {
        HttpCheckDeBug({ url: this.baseUrl + options.url, name: options.name, response })

        return { success: false, status: status || response.status }
      })
  }

  get(options) {
    return this.request(options, 'get')
  }

  post(options) {
    return this.request(options, 'post')
  }

  put(options) {
    return this.request(options, 'put')
  }

  delete(options) {
    return this.request(options, 'delete')
  }

  postform(options) {
    return this.request(options, 'postform')
  }
}
